import { render, staticRenderFns } from "./BestellungRowAbholung.vue?vue&type=template&id=6c0a1aef"
import script from "./BestellungRowAbholung.vue?vue&type=script&lang=ts"
export * from "./BestellungRowAbholung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports